import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';

export type Provision = {
  provision_id?: number; // 약관 idx
  provision_content?: string; // 약관 내용
  provision_type?: string; // 약관 타입
  created_at?: number; // 생성일
  updated_at?: number; // 수정일
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] Provision
   * --
   */
  getProvisions: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_PROVISION, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] Provision
   * --
   */
  getProvision: async (
    idx: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      const url = parameterToPath(APIConstant.GET_PROVISION, {
        provision_id: idx,
      });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Provision
   * --
   */
  createProvision: async (body: Provision) => {
    try {
      const res = await $http.post(APIConstant.CREATE_PROVISION, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] Provision
   * --
   */
  updateProvision: async (body: Provision) => {
    try {
      const { provision_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_PROVISION, {
        provision_id: provision_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] Provision
   * --
   */
  deleteProvision: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.UPDATE_PROVISION, {
        provision_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
